import styled from 'styled-components';

export const ReferenceDetailsWrapper = styled.div`
  border-radius: 1em;
  margin: 2em 0;
  padding: 1em;
  box-shadow: 0 0 11px -1px rgb(229, 229, 229);
  
  form {
    display: flex;
    flex-wrap: wrap;
    row-gap: 0.5em;
    column-gap: 0.5em;
    justify-content: space-between;
    align-items: stretch;
  }
  
  .reference-form-input{
    flex: auto;
    width: 47%;
  } 

  .reference-form-title {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .reference-form-img {
    margin-top: 1em;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1em;
    width: 100%;
    flex-direction: column;
  }

  .reference-form-img img {
    margin: 1em 0;
    width: 30vmax;
    max-width: 250px;
  }

  .reference-form-sub-heading {
    width: 100%;
    align-self: center;
    font-weight: bold;
    margin-top: 1em;
    font-size: 20px;
    color: #C6222A;
    ${(props) => (props.visible ? `display: none;` : `display: block;`)};
  }

  @media only screen and (max-width: 768px) {
    border-radius: 0;
    padding: 0;
    box-shadow: none;
    
    .reference-form-input {
      width: 100%;
    }
    
    .reference-form-input-small {
      max-width: 48%;
    }
  }

`;
